<template>
    <div>
        <form-base v-on="$listeners" v-if="!isCard" :value="value" :filter="filter" :hide-delete="hideDelete" :readonly="readonly" :hide-offset="hideOffset" :api-method="apiMethod" :fields="fields" :form-title="formTitle" :is-hover="isHover" />
        <card-base v-on="$listeners" v-if="isCard" :item="value" :filter="filter" :card-color="cardColor" :readonly="readonly" :fields="fields" :title="formTitle" />
    </div>
</template>

<script>
    export default {
        props: [
            'value',
            'filter',
            'hideDelete',
            'readonly',
            'hideOffset',
            'isCard',
            'cardColor',
            'isHover'
        ],

        components: {
            formBase: () => import('../components/FormBase'),
            cardBase: () => import('../components/CardBase')
        },

        data() {
            return {
                floralVarietyForm: () => import('../forms/FloralVarietyForm'),
                siteForm: () => import('../forms/SiteForm'),
                fields: [
                    { type: 'autocomplete', text: 'Site', value: 'siteId', rules: [v => !!v || 'Site is required'], isRequired: true, form: () => import('./SiteForm'), apiMethod: 'Sites', claim: 'Sites' },
                    { type: 'autocomplete', text: 'Floral Variety', value: 'floralVarietyId', rules: [v => !!v || 'Floral Variety is required'], isRequired: true, form: () => import('./FloralVarietyForm'), apiMethod: 'FloralVarieties', claim: 'FloralVarieties' },
                    { type: 'datetime', text: 'On', value: 'on', rules: [v => !!v || 'On is required'], isRequired: true },
                    { type: 'checkbox', text: 'Is Dominant', value: 'isDominant', rules: [v => (v !== null && v !== '') || 'Is Dominant is required'], isRequired: true },
                ],
                apiMethod: 'SiteFloralVarieties',
                formTitle: 'Site Floral Variety',
            }
        },
    };
</script>
